module.exports = __webpack_public_path__ + "img/icon_lock.329baf41.svg";